import { api } from '@api/api2';
import { ImportInterruptPayload, ImportReadNotificationPayload } from '../types';

const importsCheckNotReadStatus = () =>
  api.v4('get', 'import/check-not-read-imports-status');

const importInterrupt = (payload: ImportInterruptPayload) =>
  api.v4('get', 'import/interrupt-import', payload);

const importReadNotification = (payload: ImportReadNotificationPayload) =>
  api.v4('post', 'import/read-import-notification', payload);

export const apiImportMethods = {
  importsCheckNotReadStatus,
  importInterrupt,
  importReadNotification,
};
